module.exports = __webpack_public_path__ + "img/bird.5e015696.png";